import type { LoaderFunctionArgs, MetaFunction } from "@remix-run/cloudflare";
import { redirect } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import Container from "~/components/layout/Container";
import { buildMeta, descriptionFromHtml } from "~/lib/seo";
import { slugify } from "~/lib/slugify";
import { references } from "../_index";
import References from "../features/References";
import ServicesComponent from "../features/Services";
import { HizmetListesi } from "../hizmetlerimiz+/_index";
import { blogPosts } from "./_index";

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const post = blogPosts.find((post) => post.id === Number(params.id));
  if (!post) {
    throw new Response("Not Found", { status: 404 });
  }
  // Canonical slug kontrolü: yanlış slug ile gelindiyse doğru URL'ye 301 yönlendir.
  const canonicalSlug = slugify(post.title);
  if (params.slug !== canonicalSlug) {
    throw redirect(`/blog/${canonicalSlug}/${post.id}`, 301);
  }
  return {
    post: post, services: HizmetListesi, references: references
  }
}
export const meta: MetaFunction<typeof loader> = ({ data }) => {
  const post = data?.post;
  if (!post) {
    return buildMeta({
      title: "Yazı Bulunamadı | Al-De Mühendislik",
      description: "Aradığınız blog yazısı bulunamadı.",
      path: "/blog",
    });
  }
  return buildMeta({
    title: `${post.title} | Al-De Mühendislik Blog`,
    description: descriptionFromHtml(post.excerpt || ""),
    path: `/blog/${slugify(post.title)}/${post.id}`,
    image: post.image,
    type: "article",
  })
}
export default function Page() {
  const { post, services, references } = useLoaderData<typeof loader>();
  //blog posts sayfası
  return (
    <div className="py-20 mt-20">
      <Container className="flex-wrap">
        <h1 className="text-3xl font-bold text-center mb-12">Bizden Haberler / Blog</h1>
        <div className="flex flex-wrap">
          <div className="w-full md:w-1/3">
            <img src={post?.image} alt={post?.title} width={400} height={192} loading="lazy" className="w-full h-48 object-cover" />
          </div>
          <div className="w-full md:w-2/3 px-5">
            <h2 className="text-xl font-bold">{post?.title}</h2>
            <div key={post?.title} className="w-full text-[14px] font-lato text-[#333333]">
              <span dangerouslySetInnerHTML={{ __html: post?.excerpt || '' }} className="block mt-2 mb-8 text-base [&_h3]:text-[#16437c] [&_h3]:text-[16px] [&_h3]:font-bold [&_h3]:mt-4 [&_h3]:font-raleway [&_li]:pb-4 [&_p]:pb-4 [&_li_strong]:font-semibold [&_strong]:text-[#16437c] [&_strong]:text-[16px] [&_strong]:font-bold [&_strong]:mt-4 [&_strong]:font-raleway [&_strong]:leading-24" />
            </div>
          </div>
        </div>
      </Container>
      <ServicesComponent services={services} />
      <References references={references} />
    </div>
  )
}
